import { render, staticRenderFns } from "./news_photov2.vue?vue&type=template&id=7cc8ad0f&scoped=true"
import script from "./news_photov2.vue?vue&type=script&lang=js"
export * from "./news_photov2.vue?vue&type=script&lang=js"
import style0 from "./news_photov2.vue?vue&type=style&index=0&id=7cc8ad0f&prod&lang=css"
import style1 from "./news_photov2.vue?vue&type=style&index=1&id=7cc8ad0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc8ad0f",
  null
  
)

export default component.exports